






















































import { Component, Vue } from "vue-property-decorator";
import { State, namespace } from "vuex-class";
import ApplicationLayout from "@/layouts/ApplicationLayout.vue";
import GiftCardTiers from "@/views/global-setting/partials/GiftCardTiers.vue";
import GiftCardTiersModule from "@/store/modules/gift-card-tiers";
import { GiftCardTiersState } from "@/models/store/GiftCardTiersState";

const giftCardTiers = namespace(GiftCardTiersModule.name);

@Component({
  name: "Incentives",
  components: { ApplicationLayout, GiftCardTiers }
})

export default class Incentives extends Vue {
  // ===== Store ===== //
  @State("giftCardTiers") public readonly giftCardTiers!: GiftCardTiersState;
  @giftCardTiers.Action("getGiftCardTiers") public getGiftCardTiers!: () => void;

  // ===== Lifecycle Hook ===== //
  private async created() {
    await this.getGiftCardTiers();
  }
}
